import styled from "styled-components"

import { CallAssistActivateContent } from "src/components/CallAssistActivate/CallAssistActivateContent"
import { CallAssistActivateProvider } from "src/components/CallAssistActivate/CallAssistActivateContext"
import { DebugSettings } from "src/components/CallAssistActivate/DebugSettings"
import { useFlags } from "src/hooks/useFlags"
import { useTranslate } from "src/i18n/useTranslate"
import { ExpandableSection } from "src/ui/ExpandableSection/ExpandableSection"
import imageUrl from "src/ui/images/photo-call-assist.jpg"
import portraitImageUrl from "src/ui/images/photo-call-assist-portrait.jpg"
import { BackdropView } from "src/ui/Layout/BackdropView"
import { Show } from "src/ui/Show/Show"

export function CallAssistActivate() {
  const { t, langKeys } = useTranslate()
  const { debug } = useFlags()

  return (
    <CallAssistActivateProvider>
      <BackdropView
        title={t(langKeys.call_assist)}
        landscapeImageUrl={imageUrl}
        portraitImageUrl={portraitImageUrl}
      >
        <CallAssistActivateContent />
        <Show if={!!debug}>
          <DebugSettingsBox>
            <ExpandableSection
              title={"Debug settings"}
              id="call-assist-debug"
              storeState
            >
              <DebugSettings open={true} />
            </ExpandableSection>
          </DebugSettingsBox>
        </Show>
      </BackdropView>
    </CallAssistActivateProvider>
  )
}

const DebugSettingsBox = styled.div`
  position: absolute;
  z-index: 10;
  top: 10px;
  left: 10px;
  background: white;
  padding: 0.5rem;
`
